module.exports = __webpack_public_path__ + "img/model_48_zh.7955112c.jpg";